import React, { useContext, useState } from "react";
import { MoreDetails } from "./MoreDetails";
import { translations } from "../../../utils/lang";
import { Context } from "../../../context/Context";
import { useAccess } from "../../../access/hooks/useAccess";
import { RestaurantDetails } from "./Details";
import { Button } from "../../ui";

const GroupDetails = ({
  data,
  onSave,
  mainData,
  onSaveMain,
  moreData,
  onSaveMoreData,
  restaurantId,
}) => {
  const { lang } = useContext(Context);
  const { can } = useAccess();
  const [mode, setMode] = useState("details");

  return (
    <div className="userInfo-container">
      <div className="userInfo-top">
        <h3>
          {
            translations[lang].restaurants.restaurantsRow.details.titles[
              mode === "details" ? 0 : 1
            ]
          }
        </h3>

        {can("restaurant.details.update", { restaurantId }) && (
          <Button
            type="button"
            variant="primary"
            appearance="soft"
            onClick={() => {
              setMode(mode === "details" ? "more" : "details");
            }}
          >
            {mode === "details"
              ? translations[lang].restaurants.restaurantsRow.details.titles[1]
              : translations[lang].restaurants.restaurantsRow.details.titles[0]}
          </Button>
        )}
      </div>

      {mode === "details" ? (
        <RestaurantDetails
          restaurantId={restaurantId}
          data={data}
          onSave={onSave}
          mainData={mainData}
          onSaveMain={onSaveMain}
        />
      ) : (
        <MoreDetails
          data={moreData}
          onSave={onSaveMoreData}
          restaurantId={restaurantId}
        />
      )}
    </div>
  );
};

export default GroupDetails;
